import { inject, Injectable, Injector } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BaseClass } from '../shared/class/BaseClass';
@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService extends BaseClass {
  private confirmationService = inject(ConfirmationService);
  constructor(injector : Injector) {
    super(injector);
  }

  showConfirmationDialog(
    header: string,
    message: string,
    acceptLabel = 'Yes',
    rejectLabel = 'No'
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-exclamation-triangle',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  updateVersionConfirmationDialog(
    header: string,
    message: string,
    acceptLabel = 'Yes',
    rejectLabel = 'No'
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-cloud-download',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  showDeleteDialog(
    header: string,
    message: string,
    acceptLabel = 'Yes',
    rejectLabel = 'No'
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-exclamation-circle',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }


  NoRegionDialog(
    header: string,
    message: string,
    acceptLabel = 'OK',
    rejectLabel = 'No'
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.confirmationService.confirm({
        header,
        message,
        acceptLabel,
        rejectLabel,
        icon: 'pi pi-exclamation-triangle',
        accept: () => resolve(true),
        reject: () => resolve(false),
        rejectVisible: false,
        closable: false
      });
    });
  }
}
